const state = {
  sortedBy: [],
  displayOptions: [],
  currentItem: {}
};
const getters = {
  alertDisplayOptions: state => state.displayOptions,
  alertsSortedBy: state => state.sortedBy,
  currentAlert: state => state.currentItem
};
const actions = {
};
const mutations = {
  setAlertDisplayOptions(state, arr) {
    state.displayOptions = arr
  },
  addAlertsDisplayOption(state, [action, option]) {
    console.log(action, option)
    state[`${action}edBy`].push({[option]: 1})
  },
  replaceAlertsDisplayOption(state, [action, idx, option]) {
    state[`${action}edBy`][idx] = {[option]: 1}
  },
  removeAlertsDisplayOption(state, [action, idx, option]) {
    // Vue.delete(state[`${action}edBy`], idx, option)
  },
  switchAlertsDisplayOrder(state, [action, idx, order]) {
    let optionName = Object.keys(state[`${action}edBy`][idx])
    let idxOfOption = state[`${action}edBy`][idx]
    idxOfOption[optionName] = order
  },
  setCurrentAlert(state, object) {
    state.currentItem = object
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};